import { OutOfPageBanner } from '@/modules/adv/out-of-page-banner'
import { AdProviderNames } from '@/types'

import { AdProvider, type AdProviderConfig, AdProviderStatus, type OutOfPageAdType, type PageAdType } from '../../'

export class EmptyAdsProvider implements AdProvider {
    readonly serviceStatus: Promise<AdProviderStatus>
    private targeting: Record<string, string | string[]> = {}

    constructor({ targeting }: AdProviderConfig) {
        this.serviceStatus = Promise.resolve(AdProviderStatus.online)
        this.targeting = { ...targeting }
    }

    // eslint-disable-next-line class-methods-use-this
    prepareOutOfPageAd(): Promise<OutOfPageBanner> {
        return new Promise((res) => {
            const banner = new OutOfPageBanner({ provider: AdProviderNames.EMPTY_PROVIDER })

            setTimeout(() => {
                res(banner)
            }, 100)

            setTimeout(() => {
                banner.triggerEmpty()
            }, 200)
        })
    }

    // eslint-disable-next-line class-methods-use-this
    requestPageAd() {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject()
    }

    updateTargeting(targeting: AdProviderConfig['targeting']) {
        if (!targeting) {
            return
        }
        Object.entries(targeting).forEach(([key, value]) => {
            if (value) {
                this.targeting[key] = value
            } else {
                delete this.targeting[key]
            }
        })
    }

    // eslint-disable-next-line class-methods-use-this
    getAdUnitByType(_: OutOfPageAdType | PageAdType) {
        return undefined
    }
}
